// src/components/modals/UserAccountModal.js
import React from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM for portals
import AuthButton from '../elements/AuthButton';
import SettingsForm from '../elements/SettingsForm';
import useUserStore from '../../contexts/useUserStore';

const UserAccountModal = ({ isOpen, onClose }) => {
  const { isAuthenticated, displayName } = useUserStore();

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="relative bg-white p-6 rounded-lg w-full max-w-md max-h-screen overflow-y-auto">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <i className="bi bi-x-circle text-xl"></i>
        </button>

        {/* Username or No User Message */}
        <h2 className="text-xl mb-4 text-gray-700">
          {isAuthenticated ? `${displayName}'s settings` : "Log in to save settings"}
        </h2>

        {/* Settings Form */}
        {isAuthenticated && <SettingsForm />}

        {/* Spacer div to add space above AuthButton */}
        <div className="h-4"></div>

        {/* Log In/Log Out Button - Bottom Right */}
        <div className="absolute bottom-4 right-4">
          <AuthButton />
        </div>
      </div>
    </div>,
    document.body // Render the modal directly into the body
  );
};

export default UserAccountModal;
